<template
  ><div>
    <WebsiteHeader></WebsiteHeader>
    <div v-if="getUserSchool && getUserSchool.id">
      <div class="index-page">
        <main class="main">
          <!-- Hero Section -->
          <section id="hero" class="hero section dark-background">
            <img
              :src="
                getApiUrl +
                  '/images/website_banner/' +
                  getUserSchool.emis +
                  '/' +
                  getFrontPageImages[0]
              "
              alt=""
              data-aos="fade-in"
              class=""
            />

            <div class="container" data-aos="fade-up" data-aos-delay="100">
              <h2>{{ getUserSchool.schname }}</h2>
              <p>
                <span
                  class="typed"
                  :data-typed-items="getUserSchool.motto.split()"
                >
                </span
                ><span
                  class="typed-cursor typed-cursor--blink"
                  aria-hidden="true"
                ></span
                ><span
                  class="typed-cursor typed-cursor--blink"
                  aria-hidden="true"
                ></span>
              </p>
            </div>
          </section>
          <!-- /Hero Section -->

          <!-- About Section -->
          <section id="about" class="about section">
            <!-- Section Title -->
            <div class="container section-title" data-aos="fade-up">
              <h2>About</h2>
              <p v-html="getUserSchool.about_us"></p>
            </div>
            <!-- End Section Title -->

            <div class="container" data-aos="fade-up" data-aos-delay="100">
              <div class="row gy-4 justify-content-center">
                <div class="col-lg-4">
                  <img
                    src="assets/img/my-profile-img.jpg"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="col-lg-8 content">
                  <h2>{{ getUserSchool.schname }}</h2>
                  <p class="fst-italic py-3" v-html="getUserSchool.welcome"></p>
                  <div class="row">
                    <div class="col-lg-6">
                      <ul>
                        <li>
                          <i class="bi bi-chevron-right"></i>
                          <strong>Circuit:</strong>
                          <span>{{ getUserSchool.circuit }}</span>
                        </li>

                        <li>
                          <i class="bi bi-chevron-right"></i>
                          <strong>City:</strong>
                          <span>{{ getUserSchool.city }}</span>
                        </li>
                        <li>
                          <i class="bi bi-chevron-right"></i>
                          <strong>Address:</strong>
                          <span>{{ getUserSchool.physical_address }}</span>
                        </li>
                        <li>
                          <i class="bi bi-chevron-right"></i>
                          <strong>Phone:</strong>
                          <span>{{ getUserSchool.sch_tel }}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-lg-6">
                      <ul>
                        <li>
                          <i class="bi bi-chevron-right"></i>
                          <strong>Bank:</strong>
                          <span>{{ getUserSchool.bank }}</span>
                        </li>
                        <li>
                          <i class="bi bi-chevron-right"></i>
                          <strong>Account #:</strong>
                          <span>{{ getUserSchool.account_number }}</span>
                        </li>
                        <li>
                          <i class="bi bi-chevron-right"></i>
                          <strong>Account Type:</strong>
                          <span>{{ getUserSchool.account_type }}</span>
                        </li>
                        <li>
                          <i class="bi bi-chevron-right"></i>
                          <strong>Branch Code:</strong>
                          <span>{{ getUserSchool.branch_code }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p class="py-3" v-html="getUserSchool.short_description"></p>
                </div>
              </div>
            </div>
          </section>
          <!-- /About Section -->

          <!-- Resume Section -->
          <section id="resume" class="resume section">
            <!-- Section Title -->
            <div class="container section-title" data-aos="fade-up">
              <h2>Biography</h2>
              <p v-html="getUserSchool.biography"></p>
            </div>
            <!-- End Section Title -->

            <div class="container">
              <div class="row">
                <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                  <h3 class="resume-title">Vision</h3>

                  <div
                    class="resume-item pb-0"
                    v-html="getUserSchool.vision"
                  ></div>
                  <!-- Edn Resume Item -->

                  <!-- Edn Resume Item -->

                  <!-- Edn Resume Item -->
                </div>

                <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
                  <h3 class="resume-title">Mission</h3>
                  <div class="resume-item" v-html="getUserSchool.mission"></div>
                  <!-- Edn Resume Item -->

                  <!-- Edn Resume Item -->
                </div>
              </div>
            </div>
          </section>
          <!-- /Resume Section -->

          <!-- Services Section -->
          <section id="services" class="services section">
            <!-- Section Title -->
            <div class="container section-title" data-aos="fade-up">
              <h2>Governing Body</h2>
              <p>
                Meet our School Governing Body (SGB)! Dedicated parents,
                educators, and community members working together to guide our
                school’s vision. Together, they ensure strong leadership,
                accountability, and continuous growth for our learners.
              </p>
            </div>
            <!-- End Section Title -->

            <div class="container">
              <div class="row gy-4">
                <div
                  class="col-lg-4 col-md-6 service-item d-flex"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div class="icon flex-shrink-0">
                    <i class="bi bi-people"></i>
                  </div>
                  <div>
                    <h4 class="title">
                      Mr. Thami Buthelezi
                    </h4>
                    <p class="description">
                      Chairperson
                    </p>
                  </div>
                </div>
                <!-- End Service Item -->

                <div
                  class="col-lg-4 col-md-6 service-item d-flex"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div class="icon flex-shrink-0">
                    <i class="bi bi-people"></i>
                  </div>
                  <div>
                    <h4 class="title">
                      Mrs. Nosipho Dlamini
                    </h4>
                    <p class="description">
                      Admin Secretary
                    </p>
                  </div>
                </div>
                <!-- End Service Item -->

                <div
                  class="col-lg-4 col-md-6 service-item d-flex"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div class="icon flex-shrink-0">
                    <i class="bi bi-people"></i>
                  </div>
                  <div>
                    <h4 class="title">
                      Mr. S. G. Mdunge
                    </h4>
                    <p class="description">
                      Principal
                    </p>
                  </div>
                </div>
                <!-- End Service Item -->

                <div
                  class="col-lg-4 col-md-6 service-item d-flex"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div class="icon flex-shrink-0">
                    <i class="bi bi-people"></i>
                  </div>
                  <div>
                    <h4 class="title">
                      Mrs. M. Thabede
                    </h4>
                    <p class="description">
                      Treasurer
                    </p>
                  </div>
                </div>
                <!-- End Service Item -->

                <div
                  class="col-lg-4 col-md-6 service-item d-flex"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <div class="icon flex-shrink-0">
                    <i class="bi bi-people"></i>
                  </div>
                  <div>
                    <h4 class="title">
                      Mr. Masombuka Jwala
                    </h4>
                    <p class="description">
                      Member
                    </p>
                  </div>
                </div>
                <!-- End Service Item -->

                <div
                  class="col-lg-4 col-md-6 service-item d-flex"
                  data-aos="fade-up"
                  data-aos-delay="600"
                >
                  <div class="icon flex-shrink-0">
                    <i class="bi bi-people"></i>
                  </div>
                  <div>
                    <h4 class="title">
                      Mr. S. V. Khoza
                    </h4>
                    <p class="description">
                      Member
                    </p>
                  </div>
                </div>
                <!-- End Service Item -->
              </div>
            </div>
          </section>
          <!-- /Services Section -->

          <!-- Testimonials Section -->
          <section
            id="testimonials"
            class="testimonials section light-background"
          >
            <!-- Section Title -->
            <div class="container section-title" data-aos="fade-up">
              <h2>Blog Posts</h2>
              <p>
                Welcome to our School Blog! Discover stories, updates, and
                insights from students, teachers, and school events. Stay
                connected with the latest happenings in our vibrant learning
                community.
              </p>
            </div>
            <!-- End Section Title -->

            <div class="container" data-aos="fade-up" data-aos-delay="100">
              <div class="swiper-container" ref="testimonialSwiper">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(testimonial, index) in testimonials"
                    :key="index"
                  >
                    <div class="testimonial-item">
                      <p>
                        <i class="bi bi-quote quote-icon-left"></i>
                        <span>{{ testimonial.quote }}</span>
                        <i class="bi bi-quote quote-icon-right"></i>
                      </p>
                      <img
                        :src="testimonial.image"
                        class="testimonial-img"
                        alt=""
                      />
                      <h3>{{ testimonial.name }}</h3>
                      <h4>{{ testimonial.title }}</h4>
                    </div>
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </section>
          <!-- /Testimonials Section -->

          <!-- Contact Section -->
          <section id="contact" class="contact section">
            <!-- Section Title -->
            <div class="container section-title" data-aos="fade-up">
              <h2>Contact</h2>
              <p>
                Necessitatibus eius consequatur ex aliquid fuga eum quidem sint
                consectetur velit
              </p>
            </div>
            <!-- End Section Title -->

            <div class="container" data-aos="fade-up" data-aos-delay="100">
              <div class="row gy-4">
                <div class="col-lg-5">
                  <div class="info-wrap">
                    <div
                      class="info-item d-flex"
                      data-aos="fade-up"
                      data-aos-delay="200"
                    >
                      <i class="bi bi-geo-alt flex-shrink-0"></i>
                      <div>
                        <h3>Address</h3>
                        <p>{{ getUserSchool.physical_address }}</p>
                      </div>
                    </div>
                    <!-- End Info Item -->

                    <div
                      class="info-item d-flex"
                      data-aos="fade-up"
                      data-aos-delay="300"
                    >
                      <i class="bi bi-telephone flex-shrink-0"></i>
                      <div>
                        <h3>Call Us</h3>
                        <p>{{ getUserSchool.sch_tel }}</p>
                      </div>
                    </div>
                    <!-- End Info Item -->

                    <div
                      class="info-item d-flex"
                      data-aos="fade-up"
                      data-aos-delay="400"
                    >
                      <i class="bi bi-envelope flex-shrink-0"></i>
                      <div>
                        <h3>Email Us</h3>
                        <p>{{ getUserSchool.admin_email }}</p>
                      </div>
                    </div>
                    <!-- End Info Item -->

                    <div class="school-map">
                      <iframe
                        v-if="mapUrl"
                        :src="mapUrl"
                        frameborder="0"
                        style="border:0; width: 100%; height: 270px;"
                        allowfullscreen
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>
                  </div>
                </div>

                <div class="col-lg-7">
                  <form
                    action="forms/contact.php"
                    method="post"
                    class="php-email-form"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <div class="row gy-4">
                      <div class="col-md-6">
                        <label for="name-field" class="pb-2">Your Name</label>
                        <input
                          type="text"
                          name="name"
                          id="name-field"
                          class="form-control"
                          required=""
                        />
                      </div>

                      <div class="col-md-6">
                        <label for="email-field" class="pb-2">Your Email</label>
                        <input
                          type="email"
                          class="form-control"
                          name="email"
                          id="email-field"
                          required=""
                        />
                      </div>

                      <div class="col-md-12">
                        <label for="subject-field" class="pb-2">Subject</label>
                        <input
                          type="text"
                          class="form-control"
                          name="subject"
                          id="subject-field"
                          required=""
                        />
                      </div>

                      <div class="col-md-12">
                        <label for="message-field" class="pb-2">Message</label>
                        <textarea
                          class="form-control"
                          name="message"
                          rows="10"
                          id="message-field"
                          required=""
                        ></textarea>
                      </div>

                      <div class="col-md-12 text-center">
                        <div class="loading">Loading</div>
                        <div class="error-message"></div>
                        <div class="sent-message">
                          Your message has been sent. Thank you!
                        </div>

                        <button
                          type="submit"
                          :style="{ backgroundColor: getThemeColor }"
                        >
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <!-- End Contact Form -->
              </div>
            </div>
          </section>
          <!-- /Contact Section -->
        </main>

        <footer id="footer" class="footer position-relative light-background">
          <div class="container">
            <div class="copyright text-center ">
              <p>
                © <span>Copyright</span>
                <strong class="px-1 sitename"
                  >{{ getUserSchool.schname }}
                </strong>
                <span>All Rights Reserved</span>
              </p>
            </div>
            <div class="credits">
              Designed by
              <a href="https://baronitsolutions.co.za/">Baron IT Solutions</a>
            </div>
          </div>
        </footer>

        <!-- Scroll Top -->
        <a
          href="#"
          id="scroll-top"
          class="scroll-top d-flex align-items-center justify-content-center"
          ><i class="bi bi-arrow-up-short"></i
        ></a>

        <!-- Preloader -->
        <div id="preloader"></div>
      </div>
    </div></div
></template>

<script>
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";

import AOS from "./assets/vendor/aos/aos.js";
import "./assets/vendor/bootstrap/js/bootstrap.bundle.min.js";
import "./assets/vendor/php-email-form/validate.js";
import "./assets/vendor/aos/aos.js";
import "./assets/vendor/purecounter/purecounter_vanilla.js";
import "./assets/vendor/waypoints/noframework.waypoints.js";
import "./assets/vendor/glightbox/js/glightbox.min.js";
import Swiper from "swiper";
import "swiper/swiper-bundle.min.css";
import Typed from "typed.js";
export default {
  components: { WebsiteHeader },
  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getFrontPageImages() {
      return this.$store.getters.getFrontPageImages;
    },

    getSiteStats() {
      return this.$store.getters.getSiteStats;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAppName() {
      return this.$store.getters.getAppName;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    enableEditing() {
      return this.$store.getters.enableEditing;
    },
    features() {
      const { motto, vision, mission } = this.getUserSchool || {};
      return [
        {
          icon: "mdi-shield-outline",
          title: "Our Motto",
          text: motto || "",
        },
        {
          icon: "mdi-update",
          title: "Our Vision",
          text: vision || "",
        },
        {
          icon: "mdi-account-group-outline",
          title: "Our Mission",
          text: mission || "",
        },
      ];
    },
    mapUrl() {
      const address = this.getUserSchool && this.getUserSchool.physical_address;
      if (!address) return "";

      // Use API-enabled version if you have a Google Maps key
      // const encoded = encodeURIComponent(address);
      // return `https://www.google.com/maps/embed/v1/place?key=YOUR_GOOGLE_MAPS_API_KEY&q=${encoded}`;

      // OR free alternative without key:
      const encoded = encodeURIComponent(address);
      return `https://www.google.com/maps?q=${encoded}&output=embed`;
    },
  },

  data: () => ({
    fab: null,
    color: "transparent",
    flat: true,
    menu: [
      { icon: "mdi-home", title: "Home", route: "school-website" },
      { icon: "apps", title: "Switchboard", route: "switchboard" },
      {
        icon: "mdi-play-box-multiple",
        title: "Gallery",
        route: "images-gallery",
      },
      { icon: "assignment_ind", title: "Sign In", route: "login" },
      { icon: "person_add", title: "Create Account", route: "register" },
    ].map((item) => ({
      ...item,
      description: "",
      color: "deep-orange darken-4",
      buttonText: "Enter",
      alevel: 1,
      param: "",
    })),
    swiperInstance: null,
    testimonials: [
      {
        quote:
          "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.",
        image: "assets/img/testimonials/testimonials-1.jpg",
        name: "Saul Goodman",
        title: "Ceo & Founder",
      },
      {
        quote:
          "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.",
        image: "assets/img/testimonials/testimonials-1.jpg",
        name: "Saul Goodman",
        title: "Ceo & Founder",
      },
      {
        quote:
          "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.",
        image: "assets/img/testimonials/testimonials-1.jpg",
        name: "Saul Goodman",
        title: "Ceo & Founder",
      },
      {
        quote:
          "Export tempor illum tamen malis malis eram quae irure esse labore quem cillum quid malis quorum velit fore eram velit sunt aliqua noster fugiat irure amet legam anim culpa.",
        image: "assets/img/testimonials/testimonials-2.jpg",
        name: "Sara Wilsson",
        title: "Designer",
      },
      {
        quote:
          "Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram fore quis sint minim.",
        image: "assets/img/testimonials/testimonials-3.jpg",
        name: "Jena Karlis",
        title: "Store Owner",
      },
      {
        quote:
          "Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam.",
        image: "assets/img/testimonials/testimonials-4.jpg",
        name: "Matt Brandon",
        title: "Freelancer",
      },
      {
        quote:
          "Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid.",
        image: "assets/img/testimonials/testimonials-5.jpg",
        name: "John Larson",
        title: "Entrepreneur",
      },
    ],
  }),

  mounted() {
    this.initSwiper();
    AOS.init({
      duration: 600,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });

    this.handleScroll();
    (function() {
      "use strict";

      document.addEventListener("DOMContentLoaded", function() {
        // Header toggle
        var headerToggleBtn = document.querySelector(".header-toggle");
        var header = document.querySelector("#header");
        if (headerToggleBtn) {
          headerToggleBtn.addEventListener("click", function() {
            if (header) {
              header.classList.toggle("header-show");
            }
            headerToggleBtn.classList.toggle("bi-list");
            headerToggleBtn.classList.toggle("bi-x");
          });
        }

        // Close mobile nav on nav click
        var navLinks = document.querySelectorAll("#navmenu a");
        for (var i = 0; i < navLinks.length; i++) {
          navLinks[i].addEventListener("click", function() {
            if (document.querySelector(".header-show") && headerToggleBtn) {
              headerToggleBtn.click();
            }
          });
        }

        // Dropdown toggles
        var dropdownToggles = document.querySelectorAll(
          ".navmenu .toggle-dropdown"
        );
        for (var i = 0; i < dropdownToggles.length; i++) {
          dropdownToggles[i].addEventListener("click", function(e) {
            e.preventDefault();
            if (this.parentNode) {
              this.parentNode.classList.toggle("active");
            }
            if (this.parentNode && this.parentNode.nextElementSibling) {
              this.parentNode.nextElementSibling.classList.toggle(
                "dropdown-active"
              );
            }
            e.stopImmediatePropagation();
          });
        }

        // Preloader
        var preloader = document.querySelector("#preloader");
        window.addEventListener("load", function() {
          if (preloader && preloader.parentNode) {
            preloader.parentNode.removeChild(preloader);
          }
        });

        // Scroll to top
        var scrollTop = document.querySelector(".scroll-top");
        if (scrollTop) {
          scrollTop.addEventListener("click", function(e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          });

          function toggleScrollTop() {
            if (window.scrollY > 100) {
              scrollTop.classList.add("active");
            } else {
              scrollTop.classList.remove("active");
            }
          }

          window.addEventListener("scroll", toggleScrollTop);
          window.addEventListener("load", toggleScrollTop);
        }

        // AOS
        if (typeof AOS !== "undefined") {
          AOS.init({
            duration: 600,
            easing: "ease-in-out",
            once: true,
            mirror: false,
          });
        }

        // Typed.js
        var typed = document.querySelector(".typed");
        if (typed) {
          var itemsAttr = typed.getAttribute("data-typed-items");
          var items = itemsAttr ? itemsAttr.split(",") : [];
          new Typed(".typed", {
            strings: items,
            loop: true,
            typeSpeed: 100,
            backSpeed: 50,
            backDelay: 2000,
          });
        }

        // PureCounter
        if (typeof PureCounter !== "undefined") {
          new PureCounter();
        }

        // Skills animation
        var skillElems = document.querySelectorAll(".skills-animation");
        for (var i = 0; i < skillElems.length; i++) {
          new Waypoint({
            element: skillElems[i],
            offset: "80%",
            handler: function() {
              var bars = this.element.querySelectorAll(
                ".progress .progress-bar"
              );
              for (var j = 0; j < bars.length; j++) {
                var val = bars[j].getAttribute("aria-valuenow");
                if (val) {
                  bars[j].style.width = val + "%";
                }
              }
            },
          });
        }

        // GLightbox
        if (typeof GLightbox !== "undefined") {
          GLightbox({ selector: ".glightbox" });
        }

        // Swiper
        var swiperElements = document.querySelectorAll(".init-swiper");
        for (var i = 0; i < swiperElements.length; i++) {
          (function(el) {
            var configEl = el.querySelector(".swiper-config");
            if (configEl && configEl.textContent) {
              var config = JSON.parse(configEl.textContent.trim());
              new Swiper(el, config);
            }
          })(swiperElements[i]);
        }

        // Scrollspy
        var links = document.querySelectorAll(".navmenu a");
        function scrollSpy() {
          for (var i = 0; i < links.length; i++) {
            var hash = links[i].hash;
            if (!hash) continue;
            var section = document.querySelector(hash);
            if (!section) continue;

            var position = window.scrollY + 200;
            var start = section.offsetTop;
            var end = section.offsetTop + section.offsetHeight;

            if (position >= start && position <= end) {
              for (var j = 0; j < links.length; j++) {
                links[j].classList.remove("active");
              }
              links[i].classList.add("active");
            }
          }
        }

        window.addEventListener("scroll", scrollSpy);
        window.addEventListener("load", scrollSpy);

        // Scroll to hash on load
        window.addEventListener("load", function() {
          if (window.location.hash) {
            var section = document.querySelector(window.location.hash);
            if (section) {
              setTimeout(function() {
                var scrollMarginTop = getComputedStyle(section).scrollMarginTop;
                var marginTop = parseInt(scrollMarginTop || "0", 10);
                window.scrollTo({
                  top: section.offsetTop - marginTop,
                  behavior: "smooth",
                });
              }, 100);
            }
          }
        });
      });
    })();
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  watch: {
    fab(val) {
      this.color = val ? "secondary" : "transparent";
      this.flat = !val;
    },
  },

  methods: {
    initSwiper() {
      this.swiperInstance = new Swiper(this.$refs.testimonialSwiper, {
        loop: true,
        speed: 600,
        autoplay: {
          delay: 5000,
        },
        slidesPerView: "auto",
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 40,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 1,
          },
        },
      });
    },
    handleScroll(e) {
      var top =
        window.pageYOffset || (e && e.target && e.target.scrollTop) || 0;

      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style scoped>
@import "https://fonts.googleapis.com";
@import "https://fonts.gstatic.com";
@import "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap";
@import "./assets/vendor/bootstrap/css/bootstrap.min.css";
@import "./assets/vendor/bootstrap-icons/bootstrap-icons.css";
@import "./assets/vendor/aos/aos.css";
@import "./assets/vendor/glightbox/css/glightbox.min.css";
@import "./assets/vendor/swiper/swiper-bundle.min.css";
@import "./assets/css/main.css";
</style>
